import React from "react";
import { Link } from "react-router-dom";
import { 
  ArrowRight, ArrowLeft, Monitor, Palette, Globe, Search, 
  FileText, Target, Layout, Puzzle, CreditCard, PenTool,
  Mail, Video, Megaphone, Zap, Flag, Calendar, Camera
} from "lucide-react";

const ServicesCartePage = () => {
  // 15 services complets (incluant événementiel)
  const services = [
    {
      icon: <Monitor className="w-8 h-8" />,
      title: "Création de site vitrine",
      desc: "Site de 3 à 5 pages, responsive et optimisé pour tous les écrans.",
      price: "250",
      category: "Web"
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: "Création de logo",
      desc: "Logo unique + déclinaisons couleurs pour tous vos supports.",
      price: "250",
      category: "Design"
    },
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Stratégie réseaux sociaux",
      desc: "Calendrier éditorial + 8 publications prêtes (1 mois).",
      price: "250",
      category: "Social"
    },
    {
      icon: <Search className="w-8 h-8" />,
      title: "Audit SEO",
      desc: "Analyse technique complète + recommandations personnalisées.",
      price: "250",
      category: "SEO"
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: "Création de flyers / brochures",
      desc: "Format A5 ou A4, recto/verso, prêt pour impression.",
      price: "250",
      category: "Print"
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Campagne d'ads (mise en place)",
      desc: "Configuration + stratégie d'enchères optimisée.",
      price: "250",
      category: "Ads"
    },
    {
      icon: <Layout className="w-8 h-8" />,
      title: "Tunnel de vente",
      desc: "Landing page + séquence d'emails automatisée.",
      price: "250",
      category: "Conversion"
    },
    {
      icon: <CreditCard className="w-8 h-8" />,
      title: "Cartes de visite",
      desc: "Design premium recto/verso + fichiers HD prêts à imprimer.",
      price: "150",
      category: "Print"
    },
    {
      icon: <PenTool className="w-8 h-8" />,
      title: "Charte graphique",
      desc: "Couleurs, typographies, règles d'usage de votre identité.",
      price: "350",
      category: "Design"
    },
    {
      icon: <Mail className="w-8 h-8" />,
      title: "Signature email professionnelle",
      desc: "Design HTML compatible avec tous les clients mail.",
      price: "100",
      category: "Design"
    },
    {
      icon: <Video className="w-8 h-8" />,
      title: "Vidéo promotionnelle courte",
      desc: "Montage 30-60 secondes optimisé pour réseaux sociaux.",
      price: "350",
      category: "Vidéo"
    },
    {
      icon: <Megaphone className="w-8 h-8" />,
      title: "Community management (1 mois)",
      desc: "Animation et modération de vos réseaux sociaux.",
      price: "400",
      category: "Social"
    },
    {
      icon: <Flag className="w-8 h-8" />,
      title: "Supports événementiels",
      desc: "Roll-ups, kakémonos, badges, totems et PLV.",
      price: "300",
      category: "Événement"
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Kit communication événement",
      desc: "Invitations, programmes, signalétique complète.",
      price: "450",
      category: "Événement"
    },
    {
      icon: <Camera className="w-8 h-8" />,
      title: "Couverture social media événement",
      desc: "Live posting + création de contenu sur site.",
      price: "350",
      category: "Événement"
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero avec image */}
      <section className="relative py-24 bg-gradient-to-br from-cyan-500 to-teal-500 overflow-hidden" data-testid="services-carte-hero">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <Link 
            to="/offres" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"
            data-testid="back-to-offres"
          >
            <ArrowLeft className="w-5 h-5" />
            Retour aux offres
          </Link>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 rounded-full text-white text-sm font-medium mb-6">
                <Puzzle className="w-4 h-4" />
                Flexibilité maximale
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                Services à la Carte
              </h1>
              <p className="text-xl text-white/90 mb-4 font-medium">
                Vous avez un besoin spécifique ?
              </p>
              <p className="text-lg text-white/80 mb-8">
                Chaque service peut être adapté à votre budget et vos objectifs. 
                Choisissez exactement ce dont vous avez besoin, sans engagement supplémentaire.
              </p>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl px-8 py-4 inline-block">
                <span className="text-white/80">Tous nos services à partir de</span>
                <div className="text-4xl font-bold text-white mt-1">100 € <span className="text-lg font-normal text-white/70">/ service</span></div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                alt="Services à la carte"
                className="rounded-2xl shadow-2xl w-full"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-cyan-100 flex items-center justify-center">
                    <Zap className="w-6 h-6 text-cyan-600" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">15</div>
                    <div className="text-gray-600 text-sm">Services disponibles</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid - 12 services */}
      <section className="py-20 bg-white" data-testid="services-carte-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wider">Nos 15 services</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4">
              Choisissez ce dont vous avez besoin
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Des services individuels de qualité professionnelle, adaptables à vos besoins spécifiques.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
                data-testid={`service-${index}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-cyan-100 text-cyan-600 flex items-center justify-center group-hover:bg-cyan-500 group-hover:text-white transition-all duration-300">
                    {service.icon}
                  </div>
                  <span className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">
                    {service.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{service.desc}</p>
                <div className="flex items-center justify-between pt-6 border-t border-gray-100">
                  <div>
                    <span className="text-gray-500 text-sm">À partir de</span>
                    <div className="text-2xl font-bold text-cyan-600">{service.price} €</div>
                  </div>
                  <Link
                    to="/contact"
                    className="px-4 py-2 bg-cyan-500 text-white text-sm font-semibold rounded-full hover:bg-cyan-400 transition-colors"
                  >
                    Demander
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-20 bg-gray-50" data-testid="services-carte-avantages">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8">
              <div className="w-16 h-16 rounded-full bg-cyan-100 text-cyan-600 flex items-center justify-center mx-auto mb-6">
                <Puzzle className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Flexibilité</h3>
              <p className="text-gray-600">Choisissez uniquement les services dont vous avez besoin, sans engagement.</p>
            </div>
            <div className="text-center p-8">
              <div className="w-16 h-16 rounded-full bg-cyan-100 text-cyan-600 flex items-center justify-center mx-auto mb-6">
                <Target className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sur-mesure</h3>
              <p className="text-gray-600">Chaque service est adapté à vos objectifs et votre budget spécifique.</p>
            </div>
            <div className="text-center p-8">
              <div className="w-16 h-16 rounded-full bg-cyan-100 text-cyan-600 flex items-center justify-center mx-auto mb-6">
                <ArrowRight className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Évolutif</h3>
              <p className="text-gray-600">Commencez petit et ajoutez des services au fur et à mesure de vos besoins.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-cyan-500 to-teal-500" data-testid="services-carte-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Un besoin spécifique ?
          </h2>
          <p className="text-white/80 text-lg mb-10">
            Contactez-nous pour un devis personnalisé. Nous adaptons chaque service à votre situation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-cyan-600 font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg"
              data-testid="cta-contact-carte"
            >
              Demander un devis personnalisé
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/offres"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white/30 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-300"
            >
              Voir nos packs
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesCartePage;
